import type { AuthReplayErrorContext } from '../types/auth-replay-types'

/**
 * refresh 本身失败时抛出的结构化错误。
 *
 * 设计说明：只有 refresh 失败才应该进入“登录失效”语义；重放后的业务错误不能被包装成
 * refresh 失败，否则会把正常的权限、资源不存在或后端业务错误误判为会话失效。
 */
export class AuthRefreshFailedError extends Error {
  /** 请求入口类型。 */
  public readonly requestKind: AuthReplayErrorContext['requestKind']
  /** 请求操作名称或 URL。 */
  public readonly operation: string
  /** 下载文件 ID。 */
  public readonly fileId?: string
  /** 下载 URL。 */
  public readonly url?: string
  /** Range 字节范围。 */
  public readonly range?: string
  /** 当前连续 unauthorized 次数。 */
  public readonly attemptCount: number
  /** 最近一次 HTTP 状态码。 */
  public readonly status?: number
  /** 最近一次 RPC 错误码。 */
  public readonly code?: number
  /** refresh 失败的原始原因。 */
  public override readonly cause: unknown

  /**
   * 创建 refresh 失败错误。
   *
   * @param context 当前原始请求的鉴权重放上下文。
   */
  public constructor(context: AuthReplayErrorContext) {
    super(`auth refresh failed: requestKind=${context.requestKind}, operation=${context.operation}`)
    this.name = 'AuthRefreshFailedError'
    this.requestKind = context.requestKind
    this.operation = context.operation
    this.fileId = context.fileId
    this.url = context.url
    this.range = context.range
    this.attemptCount = context.attemptCount
    this.status = context.status
    this.code = context.code
    this.cause = context.cause
  }
}
